module.exports = __webpack_public_path__ + "../resources/img/ic_re_welcome_arc_lt.7e761d91.svg";